export default __webpack_public_path__ + "static/media/blur5.865a97f8.png";